import { SortDirection } from "react-virtualized"
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { Col, Row } from "reactstrap";

export const sortableHeaderRenderer = ({ label, dataKey, sortBy, sortDirection }) => {
    const isKeySorted = dataKey === sortBy;
    return (
        <span className="px-0" style={{ cursor: 'pointer' }}>
            <Row style={{flexFlow: 'nowrap'}}>
                <Col className="col-10 pe-0" style={{overflow:'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', alignSelf: 'center'}}>
                    {label}
                </Col>
                <Col className="ps-0">
                    {(isKeySorted && sortDirection === SortDirection.ASC) ? <FaSortUp size={24} style={{position: 'relative', bottom: '-5px'}}/> : (isKeySorted && sortDirection === SortDirection.DESC) ? <FaSortDown size={24} style={{position: 'relative', bottom: '7px'}}/> : <FaSort size={14} style={{position: 'relative', bottom: '2px'}}/>}
                </Col>
            </Row>
        </span>
    );
};